
import { Link } from 'react-router-dom';
const EventCard = ({ event }) => {
      const baseUrl = process.env.REACT_APP_API_URL;
      const imageUrl = event.EventImage?.[0]?.formats?.small?.url 
    ? `${baseUrl}${event.EventImage[0].formats.small.url}` 
    : "/path/to/default-image.jpg"; // Fallback image URL
  return (
    <div className="event-card">
        <Link to={`/events/${event.id}`} className="event-card__link">
      <img 
        className="event-card__image"
        src={imageUrl} 
        alt={event.Title}
      />
      <div className="event-card__content">
        <h3 className="event-card__title">{event.Title}</h3>
        <p className="event-card__description">{event.Description}</p>
        <div className='event-card__actions'>
            <div>
                <div>{new Date(event.Date).toLocaleDateString()}</div> 
                <div>
                Time:  {new Date(event.Date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
            </div>
           →
        </div>
      </div>
        </Link> 
    </div>
  );
};

export default EventCard;